export const projects = [
  {
    name: "Youtube Clone",
    image: "/images/youtube.png",
    alt: "Youtube clone",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.",
    github: "https://github.com/georgemwangi118/youtube-clone",
    demo: "https://youtube-clone-with-api.netlify.app/",
  },
  {
    name: "Music Player",
    image: "/images/music.png",
    alt: "Music player",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.",
    github: "https://github.com/georgemwangi118/Music_App",
    demo: "https://afro-pop.netlify.app/",
  },
  {
    name: "Dashboard",
    image: "/images/dash.png",
    alt: "dashboard",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.",
    github: "https://github.com/georgemwangi118/material-ui-dashboard",
    demo: "https://material-ui-dash.netlify.app/",
  },
  {
    name: "Real Estate",
    image: "/images/estate.png",
    alt: "Real Estate",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.",
    github: "https://github.com/georgemwangi118/Real-estate-app",
    demo: "https://gm-real-estate.netlify.app/",
  },
  {
    name: "A bank landing page",
    image: "/images/bank.png",
    alt: "Bank landing page",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.",
    github: "https://github.com/georgemwangi118/Bank-landingpage-ui",
    demo: "https://bank-landingpage-ui.netlify.app/",
  },
  {
    name: "A simple landing page",
    image: "/images/ai.png",
    alt: "Ai landing page",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.",
    github: "https://github.com/georgemwangi118/landingpage1",
    demo: "https://ai-landingpageui.netlify.app/",
  },
];
